import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu } from "lucide-react";
import logo from "./logo2.png";
import OrderTracker from "./OrderTracker"; // 👈 import tracker panel

// const CART_KEY = "cartItems";
// const getCart  = () => JSON.parse(sessionStorage.getItem(CART_KEY) || "[]");

export default function Navbar({ onMenuClick }) {
  const [showTracker, setShowTracker] = useState(false);

  // const [cartCount, setCartCount]     = useState(0);

  // // Keep cart badge in sync with sessionStorage
  // useEffect(() => {
  //   const sync = () => {
  //     const cart = getCart();
  //     setCartCount(cart.reduce((s, i) => s + i.qty, 0));
  //   };
  //   sync();
  //   // Re-sync whenever storage changes (other tabs / components)
  //   window.addEventListener("storage", sync);
  //   // Poll every second for same-tab updates
  //   const interval = setInterval(sync, 1000);
  //   return () => {
  //     window.removeEventListener("storage", sync);
  //     clearInterval(interval);
  //   };
  // }, []);

  const styles = {
    navbar: {
      width: "100%",
      backgroundColor: "#ffffff",
      boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
      position: "sticky",
      top: 0,
      zIndex: 1000,
      padding: "20px 0",
      height: "60px",
    },
    container: {
      maxWidth: "1200px",
      margin: "0 auto",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "0 20px",
      position: "relative",
    },
    hamburger: {
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
    },
    brand: {
      position: "absolute",
      left: "50%",
      transform: "translateX(-50%)",
      display: "flex",
      alignItems: "center",
      textDecoration: "none",
    },
    logo: {
      width: "250px",
      height: "60px",
      objectFit: "contain",
    },
    // Orders button on the right
    ordersBtn: {
      position: "relative",
      display: "flex",
      alignItems: "center",
      gap: 6,
      border: "none",
      background: "#11111100",
      borderRadius: 99,
      cursor: "pointer",
      color: "#fff",
      fontSize: 13,
      fontWeight: 700,
      whiteSpace: "nowrap",
      WebkitTapHighlightColor: "transparent",
    },
    ordersBtnIcon: {
      fontSize: 20,
      padding:0,
      lineHeight: 1,
    },
    ordersBadge: {
      position: "absolute",
      top: -5,
      right: -5,
      background: "#111",
      color: "#fff",
      fontSize: 9,
      fontWeight: 800,
      borderRadius: 99,
      minWidth: 17,
      height: 17,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "0 3px",
      border: "2px solid #fff",
    },
  };

  return (
    <>
      <nav style={styles.navbar}>
        <div style={styles.container}>

          {/* Hamburger */}
          <div style={styles.hamburger} onClick={onMenuClick}>
            <Menu size={28} />
          </div>

          {/* Center Logo */}
          <Link to="/" style={styles.brand}>
            <img src={logo} alt="Logo" style={styles.logo} />
          </Link>

          {/* Right — My Orders button */}
 <button
  style={styles.ordersBtn}
  onClick={() => setShowTracker(true)}
>

  <span style={styles.ordersBtnIcon}>
    📦
  </span>

  {/* {cartCount > 0 && (
    <span style={styles.ordersBadge}>
      {cartCount}
    </span>
  )} */}

</button>

        </div>
      </nav>

      {/* Order Tracker Side Panel */}
      {showTracker && (
        <OrderTracker onClose={() => setShowTracker(false)} />
      )}
    </>
  );
}